import Vue from 'vue'
import VueAnalytics from 'vue-ua'
import VueRouter from 'vue-router'
import DefaultLayout from '@/layouts/Default.vue'

Vue.use(VueRouter)
const nameMenu = 'Sobre Nós'
const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/pages/Home.vue'),
        meta: { analytics: 'Home' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/pages/Contacts.vue'),
        meta: { analytics: 'Contacts' }
      },
      {
        path: 'about',
        redirect: { name: 'About', params: { about: nameMenu.toLowerCase().replace(/\s+/g, '-'), menu: nameMenu } },
        meta: { analytics: 'About' }
      },
      {
        path: 'about/:about'.toLowerCase(),
        name: 'About',
        component: () => import('@/pages/About.vue'),
        meta: { analytics: 'About' }
      },
      /* {
        path: 'cases',
        component: () => import('@/pages/Cases.vue'),
        children: [
          {
            path: '',
            name: 'Cases',
            component: () => import('@/components/People/Index'),
            meta: { analytics: 'Cases' }
          },
          {
            path: ':id',
            name: 'Case',
            component: () => import('@/components/People/CardMaximized/Index'),
            meta: { analytics: 'Case' }
          }
        ]
      },
      */
      {
        path: 'solutions',
        redirect: { name: 'Solutions', params: { solution: 'UContact' } },
        meta: { analytics: 'Solutions' }
      },
      {
        path: 'solutions/:solution'.toLowerCase(),
        name: 'Solutions',
        component: () => import('@/pages/Solutions.vue'),
        meta: { analytics: 'Solutions' }
      },
/*       {
        path: 'events',
        name: 'Events',
        component: () => import('@/pages/Events.vue'),
        meta: { analytics: 'Events' }
      }, */
      {
        path: 'people',
        name: 'People',
        component: () => import('@/pages/People.vue'),
        meta: { analytics: 'People' }
      },
      {
        path: 'responsibility',
        name: 'Responsibility',
        component: () => import('@/pages/Responsibility.vue'),
        meta: { analytics: 'Responsibility' }
      },
      {
        path: 'responsibility/View',
        name: 'ResponsibilityView',
        component: () => import('@/components/Responsibility/ItemView.vue'),
        meta: { analytics: 'Responsibility' }
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/pages/Login.vue')
      },
      {
        path: 'recover',
        name: 'Recover',
        component: () => import('@/pages/Recover.vue')
      },
      {
        path: 'politica-de-cookies',
        name: 'CookiePolicy',
        component: () => import('@/pages/CookiesPolicy.vue'),
        meta: { analytics: 'CookiesPolicy' }
      },
      {
        path: 'politica-de-privacidade',
        name: 'PrivacyPolicy',
        component: () => import('@/pages/PrivacyPolicy.vue'),
        meta: { analytics: 'PrivacyPolicy' }
      },
      {
        path: 'termos-condicoes',
        name: 'TermsConditions',
        component: () => import('@/pages/TermsConditions.vue'),
        meta: { analytics: 'TermsConditions' }
      },
      {
        path: 'info-chat-bot',
        name: 'InfoChatBot',
        component: () => import('@/pages/InfoChatBot.vue'),
        meta: { analytics: 'InfoChatBot' }
      },
      {
        path: '*',
        name: 'not_found',
        redirect: { name: 'Home' }
      }
      /*  {
        path: 'events',
        name: 'events',
        component: () => import('@/pages/Events.vue'),
        meta: { analytics: 'Events' }
      },
      {
        path: 'events/:events'.toLowerCase(),
        name: 'Events',
        component: () => import('@/pages/Events.vue'),
        meta: { analytics: 'Events' }
      } */
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active-route',
  base: process.env.BASE_URL,
  routes
})

// Initialize Analytics only if user consented to cookies
try {
  const consent = typeof window !== 'undefined' ? window.localStorage.getItem('cookie_consent') : null
  if (consent === 'accepted') {
    Vue.use(VueAnalytics, {
      appName: 'Ucall Website',
      appVersion: '1.0.0',
      trackingId: process.env.VUE_GOOGLE_ANALYTICS || 'UA-155367306-1',
      trackPage: true,
      vueRouter: router
    })
  }
} catch (e) {
  // ignore
}

export default router
